export const Logo = ({ small }) => (
  <div className="flex items-center gap-3 select-none" data-testid="brand-logo">
    <svg width={small ? 34 : 46} height={small ? 24 : 32} viewBox="0 0 46 32" fill="none">
      <path d="M2 9c6-6 12-6 18 0s12 6 18 0" stroke="#F4B842" strokeWidth="3.2" strokeLinecap="round" />
      <path d="M2 17c6-6 12-6 18 0s12 6 18 0" stroke="#F8D27A" strokeWidth="3.2" strokeLinecap="round" />
      <path d="M2 25c6-6 12-6 18 0s12 6 18 0" stroke="#22C3E6" strokeWidth="3.2" strokeLinecap="round" />
    </svg>
    <div className="leading-none">
      <div className={`${small ? "text-xl" : "text-[27px]"} font-semibold tracking-[0.14em] text-white`}>VAAL</div>
      <div className="text-[9.5px] tracking-[0.32em] text-slate-200 mt-1">INVESTMENT GATEWAY</div>
    </div>
  </div>
);
